var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00078 3.3L1.34453 9.975C1.19453 10.125 1.01641 10.2 0.810156 10.2C0.603906 10.2 0.425781 10.125 0.275781 9.975C0.125781 9.825 0.0507812 9.64688 0.0507812 9.44063C0.0507812 9.23438 0.125781 9.05625 0.275781 8.90625L6.95078 2.25H1.25078C1.03828 2.25 0.860156 2.17813 0.716406 2.03438C0.572656 1.89063 0.500781 1.7125 0.500781 1.5C0.500781 1.2875 0.572656 1.10938 0.716406 0.965625C0.860156 0.821875 1.03828 0.75 1.25078 0.75H8.75078C8.96328 0.75 9.14141 0.821875 9.28516 0.965625C9.42891 1.10938 9.50078 1.2875 9.50078 1.5V9C9.50078 9.2125 9.42891 9.39063 9.28516 9.53438C9.14141 9.67813 8.96328 9.75 8.75078 9.75C8.53828 9.75 8.36016 9.67813 8.21641 9.53438C8.07266 9.39063 8.00078 9.2125 8.00078 9V3.3Z",
    fill: "var(--color-primary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenNew);
export default __webpack_public_path__ + "static/media/OpenNew.b9550b2d.svg";
export { ForwardRef as ReactComponent };